// segment.js
// Segment IO tracking
import $ from 'jquery';
import _ from 'lodash';
import radio from 'radio';
import { REGISTER_PAGE_VIEW, TRACK, CLICK, SUBMIT } from 'shared/enums/events';

const data = () => {
  let obj = {};
  const segmentData = $('#page-segment-values .keyvals').data();
  if (segmentData) {
    const pairs = _.toPairs(segmentData).map((dataPair) => {
      const pair = dataPair;
      pair[0] = _.camelCase(pair[0]);
      pair[1] = (pair[1] === '') ? null : pair[1];
      return pair;
    });
    obj = _.fromPairs(pairs);
  }

  obj = _.defaults({
    referrer: document.referrer,
    search: location.search,
    url: document.location.href,
    path: window.location.pathname,
    contentCmsTerms: (_.get(obj, 'contentCmsTerms') || '').split(','),
    contentAuthorName: (_.get(obj, 'contentAuthorName') || '').split(','),
  }, obj);

  return obj;
};

const track = (eventName, newData = {}) => {
  if (window.analytics && eventName && !_.isEmpty(newData)) {
    window.analytics.track(eventName, newData);
  }
};

const view = (newData = {}) => {
  const obj = Object.assign({}, newData, data());
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
};

const onClickTarget = (event, $target) => {
  const $zone = $target.closest('[data-tracking-zone]');

  // Track clicks to content if in a labeled data tracking zone.
  if ($zone.length) {
    const destinationProperties = {
      contentUrl: $target.closest('a').attr('href'),
      contentHeadline: _.trim($target.closest('article').find('.headline').text()),
      clickType: $target.closest('a').find('img').length ? 'image' : 'text',
    };

    const sourceData = data();

    // Used for 'Clicked to Content' event tracking.
    // Renames keys in sourceData and include extra properties
    const sourceProperties = {
      sourceSection: $zone.attr('data-tracking-zone'),
      sectionPosition: $target.closest('.component.feed').length
      ? $target.closest('.component.feed').find('article').index($target.closest('article')) + 1
      : null,
      sourceContentAuthorName: sourceData.contentAuthorName,
      sourceContentCmsTerms: sourceData.contentCmsTerms,
      sourceContentUrl: sourceData.url,
      sourceContentModifiedDate: sourceData.contentModifiedDate,
      sourceContentPublishedDate: sourceData.contentPublishedDate,
      sourceContentHeadline: sourceData.contentHeadline,
      sourceContentType: sourceData.contentType,
      sourceContentCmsTags: sourceData.contentCmsTags,
      sourceContentCmsCategory: sourceData.contentCmsCategory,
      sourceContentCmsSubCategory: sourceData.contentCmsSubCategory,
      sourceContentShownOnPlatform: sourceData.contentShownOnPlatform,
      sourceContentFeaturedImage: sourceData.contentFeaturedImage,
      sourceContentCmsId: sourceData.contentCmsId,
      sourceTimeIncBrand: sourceData.timeIncBrand,
    };

    const contentActionProperties = {
      label: `clicked ${$target.closest('span.icon').length ? 'to share' : 'link'}`,
      socialService: $target.closest('span').attr('data-social-service') ? $target.closest('span').attr('data-social-service') : null,
      link: !$target.closest('a').find('svg').length ? $target.closest('a').text() : null,
      userDecisionArea: $zone.attr('data-tracking-zone'),
    };

    // Used for 'Navigation Action Taken' event tracking for the 'label' property.
    let navLabel;

    if ($target.closest('span').attr('data-social-service')) {
      navLabel = 'clicked to social';
    } else if ($target.closest('form').length) {
      navLabel = 'searched';
    } else if ($target.closest('button.menu').length) {
      navLabel = 'clicked hamburger';
    } else if ($zone.attr('data-tracking-zone') === 'nav' && $target.closest('footer').length) {
      navLabel = 'clicked footer menu item';
    } else {
      navLabel = 'clicked hamburger item';
    }

    const navActionProperties = {
      socialService: $target.closest('span').attr('data-social-service') ? $target.closest('span').attr('data-social-service') : null,
      userDecisionArea: $target.closest('footer').length ? 'footer' : $zone.attr('data-tracking-zone'),
      menuItem: $target.closest('a').text().trim(),
      searchTerm: $target.closest('form').find('input[name=q]') ? $target.closest('form').find('input[name=q]').val() : null,
      label: navLabel,
    };

    const contentActionZones = ['top-menu', 'body', 'author'];
    const navActionZones = ['nav', 'footer'];

    // Only track when there is a destination URL or on search submit from navigation
    if (destinationProperties.contentUrl || navActionProperties.searchTerm) {
      event.preventDefault();

      _.defer(() => {
        // Re-trigger the event.
        if (!$target.closest('a').hasClass('popup')) {
          if ($target.closest('a').attr('target') === '_blank') {
            window.open(destinationProperties.contentUrl);
          } else {
            window.location = destinationProperties.contentUrl;
          }
        }
      });

      // Fire tracking based on data-tracking-zone.
      if (contentActionZones.includes($zone.attr('data-tracking-zone'))) {
        if ($target.closest('a').length) {
          // Fire when any actions occur within the content (i.e. inline links).
          track('Content Action Taken', Object.assign(sourceData, contentActionProperties));
        }
      } else if (navActionZones.includes($zone.attr('data-tracking-zone'))) {
        // Fire for any interactions with share tools, menus, footers and navigation
        // (i.e. menu item, social icon in nav).
        track('Navigation Action Taken', Object.assign(sourceData, navActionProperties));
      } else {
        // Fire when any content in bottom-recirc, right-rail, or under-nav is clicked
        // (i.e. Outbrain link in bottom-recirc).
        track('Clicked to Content', Object.assign(destinationProperties, sourceProperties));
      }
    }
  }
};

const onSubmit = (event, $target) => {
  // Run event tracking for form submit
  onClickTarget(event, $target);
};

export default {
  data,
  track,
  view,
  load() {
    const obj = data();
    if (window.analytics) {
      window.analytics.page(obj);
    }
    if (obj.experimentName && obj.variationName) {
      track('Experiment Viewed', {
        experiment_name: obj.experimentName,
        variation_name: obj.variationName,
      });
    }
  },
  listener() {
    radio(REGISTER_PAGE_VIEW).subscribe(view);
    radio(TRACK).subscribe(track);
    radio(CLICK).subscribe(onClickTarget);
    radio(SUBMIT).subscribe(onSubmit);
  },
};



// WEBPACK FOOTER //
// ./~/unicorn/public/src/utils/segment.js
